import { connect } from 'react-redux';
import ArticleList from '../articleList';
import connectionType from '../../../utils/connections/connectionType';
import createArticleProps from '../../../utils/connections/createArticleProps';
import { panelType } from '../../../../shared/constants';

const titles = {
  [connectionType.citesYourPaper]: 'Articles that were written by you',
  [connectionType.citesYourCitation]: 'Articles that you have cited before',
  [connectionType.citesCoAuthor]: 'Articles that were written by one of your co-authors',
  [connectionType.citesYourCiter]: 'Articles that have cited you',
};

const mapStateToProps = (state, ownProps) => {
  const { type } = ownProps;
  const { connections: { data } } = state;
  const connectedArticles = data[type];

  const articleProps = connectedArticles.map(createArticleProps);

  const articles = articleProps.map((props, index) => ({
    ...props,
    key: props.eid,
    articlePreviewPanel: panelType.connectionsArticlePreview,
    articlePreviewProps: {
      type,
      index,
    },
  }));

  return {
    articles,
    title: titles[type],
  };
};

export default connect(mapStateToProps)(ArticleList);
